import React, {useContext} from 'react';
import { Link } from "react-router-dom";
import { UserContext } from '../../Contexts/UserContext';
import { useNavigate } from "react-router";
import Role from '../../Helpers/Role';
import { hasPermission } from '../../Utils/PermissionUtils';
import { Permission } from '../../Utils/Permission';

const UserProfileLeftNav = (props) => {
    const {user, selectedOrgId, signOut} = useContext(UserContext);
    const navigate = useNavigate();

    const isAdmin = () => {
        const orgRole = user.userRoles.find(u => u.roleId == 2);
        return orgRole != null;
    };

    return (
        <div className="left-nav">
            <a className="profile-back-link" onClick={() => navigate(-1)}><i></i> Back</a>
            <ul>
                <li><Link to="/profile" className={props.section == "profile" ? "active" : ""}>Profile</Link></li>
                <li><Link to="/settings" replace className={props.section == "settings" ? "active" : ""}>Settings</Link></li>
                {
                    hasPermission(user, Permission.UserView, selectedOrgId) && 
                    <li><Link to="/members" replace className={props.section == "members" ? "active" : ""}>Members</Link></li>
                }
                {
                    hasPermission(user, Permission.GeoJsonTypeView, selectedOrgId) && 
                    <li><Link to="/geojsontypes" replace className={props.section == "geojsontypes" ? "active" : ""}>GeoJson Types</Link></li>
                }
                {
                    !user.isClientUser && isAdmin() && 
                    <li><Link to="/contacts" replace className={props.section == "contacts" ? "active" : ""}>Contacts</Link></li>
                }
                {
                    !user.isClientUser && hasPermission(user, Permission.OrgView, selectedOrgId) && 
                    <li><Link to="/organization" replace className={props.section == "organization" ? "active" : ""}>Organization</Link></li>
                }
                <li><Link to="/clearcache" replace className={props.section == "clearcache" ? "active" : ""}>Clear Cache</Link></li>
                <li className="logout"><Link to="/" onClick={()=> signOut()}>Log Out</Link></li>
            </ul>
        </div>
    );
}

export default UserProfileLeftNav;